import * as R from 'remeda';
import { Component, EventEmitter, OnInit, Output, ViewChild, PipeTransform, Pipe } from '@angular/core';
import { WorkFlowListData, ListConfig } from './workflow.datasource';
import { Input } from '@angular/core';
import { Cf2MaterialModule} from "@modules/cf2-material/cf2-material.module";
import { MatSort } from '@angular/material/sort';
import { TaskModel } from '@api/models';
import { TranslocoDirective, TranslocoService} from '@jsverse/transloco';
import { MatTableDataSource} from "@angular/material/table";
import { DatePipe, NgForOf } from "@angular/common";
import { WorkflowService } from '@api/services';
import { take } from 'rxjs';

@Component({
  selector: 'cf2-expenditure-workflows-list',
  templateUrl: './expenditure-workflows-list.component.html',
  styleUrls: ['./expenditure-workflows-list.component.scss'],
  imports: [
    Cf2MaterialModule,
    TranslocoDirective,
    DatePipe,
    NgForOf
  ],
})
export class ExpenditureWorkflowsListComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() isReady = false;
  @Output() selectedTask = new EventEmitter<TaskModel>();

  dataSub = new MatTableDataSource<any>();
  columnConfig: ListConfig[];

  columns: any;
  resultCount: number;

  constructor(private translocoService: TranslocoService,
    private workflSvc: WorkflowService,
  ) {
    const tableSetup = new WorkFlowListData(translocoService);
    this.columnConfig = tableSetup.config;
    this.columns = this.columnConfig.map((column) => column.key);
  }

  ngOnInit(): void {
    this.dataSub.sortingDataAccessor = (item, property) => {
      if (property === 'dueDateFormatted') {
        return item[property]
          ? new Date(item[property]).getTime()
          : 0;
      }
      return item[property];
    };

    this.dataSub.sort = this.sort;
    this.loadData();
  }

  /*return true if date string greater than curr date */
  ltCurrDate(dateStr: string) {
    const currDate: Date = new Date();
    const testDate: Date = new Date(Date.parse(dateStr));
    return testDate.getTime() < currDate.getTime();
  }

  loadData() {
    this.workflSvc
      .apiWorkflowGet$Json$Response({})
      .pipe(take(1))
      .subscribe((response) => {
        if (response.status !== 200) {
          this.isReady = true;
          return console.log('data failed to load with ', response.status);
        }
        const sorted = R.sortBy(response.body, (rec) => rec.dueDate);

        this.dataSub.data = sorted;
        this.dataSub.sort = this.sort;
        this.resultCount = response?.body?.length;
        this.isReady = true;
      });
  }

  public refNavigate(task: TaskModel) {
    this.selectedTask.emit(task);
  }

  viewExpenditure(data: TaskModel) {
    this.selectedTask.emit(data);
  }
}
